export default __webpack_public_path__ + "static/media/logo_alcaldia_mayor_bogota.971b2375.svg";